import React from "react";
import "./nav.css"
import Toggle from "../components/toggle/Toggle";


// handlechange will be use only for multiple pages website
function NavTabs({ currentPage, handlePageChange }) {
  return (
    <div className="navContainer">
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <a
            href="#home"
            className={currentPage === "Home" ? "nav-link active" : "nav-link"}
          >
            Home
          </a>
        </li>


        <li className="nav-item">
          <a
            href="#works"

            className={currentPage === "Works" ? "nav-link active" : "nav-link"}
          >
            Portfolio
          </a>
        </li>
        <li className="nav-item">
          <a
            href="#resume"
            className={currentPage === "Resume" ? "nav-link active" : "nav-link"}
          >
            Resume
          </a>
        </li>


        <li className="nav-item">
          <a
            href="#about"
            className={currentPage === "About" ? "nav-link active" : "nav-link"}
          >
            About
          </a>
        </li>


        <li className="nav-item">
          <a
            href="#contact"
            className={currentPage === "Contact" ? "nav-link active" : "nav-link"}
          >
            Contact
          </a>
        </li>

        <div className="toggle">
          <Toggle />
        </div>

      </ul>

    </div>

  );
}

export default NavTabs;
